import React from "react";
import iconAdd from "../../Resources/svg/icon-add.svg";

const ListAddresses = ({address, setAddress, setOpen}: any) => (
  <div className="addressesContainer">
    {Object.keys(address).length > 0 ?
      <div className="addresses">
        <div className="addresses__item">
          <span className="addresses__item__selected"></span>
          <p className="addresses__item__title">dirección 1</p>
          <p className="addresses__item__description">
            {`${address.type}. ${address.name.toUpperCase()} ${address.number}`}  
          </p>
          <p className="addresses__item__delete">
            <span onClick={() => setAddress({})}>Eliminar</span>
          </p>
        </div>
      </div>
      :
      <button type="button" className="add" onClick={() => setOpen(true)}>
        <img src={iconAdd}/> 
        <span>Agregar dirección</span>
      </button>
    }
  </div>
);

export default ListAddresses;